/**
 * @generated SignedSource<<d04af8f9cff4ade253be2ec912684df8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type employmentSpecialRelationshipsCurrentQuery$variables = {
  refundHistoryId: string;
};
export type employmentSpecialRelationshipsCurrentQuery$data = {
  readonly getSurveyEmploymentAnswer: {
    readonly employmentAnswer: {
      readonly specialRelationshipsCurrently: ReadonlyArray<{
        readonly birthday: string | null | undefined;
        readonly ieNm: string;
      }>;
    } | null | undefined;
    readonly result: boolean;
  };
};
export type employmentSpecialRelationshipsCurrentQuery = {
  response: employmentSpecialRelationshipsCurrentQuery$data;
  variables: employmentSpecialRelationshipsCurrentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "refundHistoryId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "refundHistoryId",
        "variableName": "refundHistoryId"
      }
    ],
    "concreteType": "SurveyEmploymentAnswerOutput",
    "kind": "LinkedField",
    "name": "getSurveyEmploymentAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyEmploymentAnswer",
        "kind": "LinkedField",
        "name": "employmentAnswer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EmployeeWithoutTin",
            "kind": "LinkedField",
            "name": "specialRelationshipsCurrently",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ieNm",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "birthday",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "employmentSpecialRelationshipsCurrentQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "employmentSpecialRelationshipsCurrentQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4cd0673921d670a91f7bbf3a1a740861",
    "id": null,
    "metadata": {},
    "name": "employmentSpecialRelationshipsCurrentQuery",
    "operationKind": "query",
    "text": "query employmentSpecialRelationshipsCurrentQuery(\n  $refundHistoryId: String!\n) {\n  getSurveyEmploymentAnswer(refundHistoryId: $refundHistoryId) {\n    result\n    employmentAnswer {\n      specialRelationshipsCurrently {\n        ieNm\n        birthday\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "309f3f488b187d032f76e9d97eb2c8b8";

export default node;
